import { BoltOutlined } from '@mui/icons-material';
import { Button, Menu, MenuList, PopoverOrigin, styled, Tooltip } from '@mui/material';
import { useButtonMenu } from '@procureai/ui-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { ConversationQuickAction } from '../../ConversationQuickAction';
import { I18nNamespace } from '~/common/types';
import { useQuickActions } from '~/components/ConversationContextProvider/ConversationContextProvider.hook';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

const StyledMenuList = styled(MenuList)(({ theme }) => ({
  // Ensure spacing around and between items
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  // Enable scrolling and enforce inclusion of bottom padding
  // by setting overflow explicitly to the menu list
  maxHeight: 300,
  overflowY: 'auto',
}));

export interface QuickActionsMenuProps {
  disabled?: Union.Nullable<boolean>;
}

export const QuickActionsMenu = ({ disabled }: QuickActionsMenuProps) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'ConversationInput.action' });
  const { quickActions, onSubmit } = useQuickActions();

  const isDisabled = disabled || isEmpty(quickActions);
  const { menuProps, buttonProps } = useButtonMenu();
  return (
    <>
      <Tooltip title={t('quickActions')} placement="top">
        <Button variant="text" size="medium" sx={{ p: 2 }} disabled={isDisabled} {...buttonProps}>
          <BoltOutlined />
        </Button>
      </Tooltip>
      <Menu
        {...menuProps}
        disableScrollLock
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
        slots={{ list: StyledMenuList }}
      >
        {quickActions?.map((action) => (
          <ConversationQuickAction key={action.id} action={action} onSubmit={onSubmit} />
        ))}
      </Menu>
    </>
  );
};
